// Auto generated file, do not manually modify!
// com.hotpads.listingdatamodeltypes.enums.LeaseDuration

export enum LeaseDuration {
  ONE_MONTH = 'ONE_MONTH',
  ONE_YEAR = 'ONE_YEAR',
  RENT_TO_OWN = 'RENT_TO_OWN',
  SIX_MONTH = 'SIX_MONTH',
  SUBLET_TEMPORARY = 'SUBLET_TEMPORARY',
}

export const LeaseDuration_values = [
  LeaseDuration.ONE_MONTH,
  LeaseDuration.ONE_YEAR,
  LeaseDuration.RENT_TO_OWN,
  LeaseDuration.SIX_MONTH,
  LeaseDuration.SUBLET_TEMPORARY,
] as const;
